import React, { useRef, useState } from 'react';

const OTPInput = ({ length = 5, onChange, disabled }) => {
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputs = useRef([]);

  const handleChange = (element, index) => {
    const value = element.value;

    if (!/^[0-9a-zA-Z]$/.test(value) && value !== '') {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputs.current[index + 1].focus();
    }

    if (onChange) {
      onChange(newOtp.join(''));
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace') {
      if (otp[index] === '') {
        if (index > 0) {
          inputs.current[index - 1].focus();
        }
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);

        if (onChange) {
          onChange(newOtp.join(''));
        }
      }
    }
  };

  const handlePaste = event => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text').slice(0, length);
    const newOtp = [...otp];
    pasteData.split('').forEach((char, index) => {
      if (index < length) {
        newOtp[index] = char;
      }
    });
    setOtp(newOtp);

    if (onChange) {
      onChange(newOtp.join(''));
    }

    if (pasteData.length < length) {
      inputs.current[pasteData.length].focus();
    }
  };

  return (
    <div className='otpinput_container'>
      {otp.map((value, index) => (
        <input
          key={`otpcontainer_${index}`}
          type='text'
          value={value}
          maxLength={1}
          onChange={e => handleChange(e.target, index)}
          onKeyDown={e => handleKeyDown(e, index)}
          onPaste={handlePaste}
          disabled={disabled}
          ref={el => (inputs.current[index] = el)}
          className='otpinput_container__box'
        />
      ))}
    </div>
  );
};

export default OTPInput;
